import ContainerModalComponent from "./ContainerModalComponent.vue";
import Vue from "vue";
import ContainerBase from 'client/src/view-container/container-vue-base';

export default class ContainerModal extends ContainerBase {
  createVueComponent() {
    return new Vue(ContainerModalComponent);
  }
}
